<template>
	<el-popconfirm
		v-if="['00','03','04','05','06'].includes(flowStatus)"
		title="确认移除?"
		size="mini"
		icon="el-icon-info"
		icon-color="red"
		@confirm="confirm"
	>
		<template #reference>
			<el-button type="text" class="remove-color">移除</el-button>
		</template>
	</el-popconfirm>
</template>
<script lang="ts">
import $api from "@/api/main";
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
export default defineComponent({
	props: {
		removeApiName: String,
		removeId: [String, Number],
		flowStatus: [String, Number],
	},
	emits:['removeSuccess'],
	setup(props: any, { emit }: any) {
		const confirm = () => {
			$api[props.removeApiName](props.removeId).then((res: any) => {
				if (res) {
					ElMessage.success("移除成功");
					emit("removeSuccess", true);
				}
			});
		};
		return {
			confirm,
		};
	},
});
</script>
<style lang="less" scoped>
.remove-color {
	color: #f56c6c;
}
</style>
